import { NextRouter } from "next/router";

export const removeQueryParams = (router: NextRouter, ...params: string[]) => {
    const { pathname } = router;
    const searchParams = new URLSearchParams(window.location.search);
    params.forEach((param) => searchParams.delete(param));

    router.replace({ pathname, query: searchParams.toString() }, undefined, {
        shallow: true,
    });
};
